/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Screen_WorkInputs */

const vi_station_screen_work = /** @type {(inputs: Station_Screen_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Công việc`)
};

/**

* @param {Station_Screen_WorkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_screen_work = /** @type {((inputs?: Station_Screen_WorkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Screen_WorkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_screen_work(inputs)
});